import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { ReportsPermissionResolver } from '../reports/reports-permission.resolver';

export class DashboardRouteDefinition {
  public static getRoutes(): RouteDefinition {
    return {
      path: RoutePaths.DASHBOARD,
      title: 'Dashboard',
      icon: 'icon-dashboard.svg',
      position: 1,
      resolver: ReportsPermissionResolver
    };
  }
}
